import { useTranslation } from "react-i18next";
import Dialog from "components/shared/Dialog";
import Button from "components/shared/Button";
import ResponseTable, { type TransferResult } from "./Transfer/ResponseTable";

interface EventResultsProps {
    title?: string;
    results: TransferResult[] | null;
    close: () => void;
}

function EventResults({ title, results, close }: EventResultsProps) {
    const { t } = useTranslation();

    return (
        <Dialog
            title={title ?? t("event-save-results")}
            open={!!results}
            close={close}
            size="4xl"
        >
            <div className="tw-flex tw-flex-col tw-gap-4 tw-p-5">
                <ResponseTable data={results || []} />
                <div className="tw-flex tw-justify-end">
                    <Button type="button" onClick={close}>
                        {t("close")}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

export default EventResults;
